import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { useMsal } from "@azure/msal-react";
import { createZammadAxiosInstance, GET_CURRENT_USER_ZAMMAD } from "../utils/ZammadServices";

const ZammadContext = createContext(null);

export const ZammadProvider = ({ children }) => {
  // Usar useRef para mantener la referencia de la instancia de Axios sin transformarla
  const zammadInstanceRef = useRef(null);
  const [zammadUser, setZammadUser] = useState(null);
  const [zammadError, setZammadError] = useState(null);
  const [instanceReady, setInstanceReady] = useState(false);
  const { accounts } = useMsal();

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const userEmail = accounts[0].username;

      // Crear instancia de Zammad con Basic Auth
      const instance = createZammadAxiosInstance(userEmail);

      // Verificar que realmente sea una instancia de Axios
      if (!instance || typeof instance.get !== 'function' || typeof instance.post !== 'function') {
        console.error('ERROR: createZammadAxiosInstance no retornó una instancia válida de Axios!');
        return;
      }

      // Guardar la instancia en el ref (no causa re-render, mantiene la referencia exacta)
      zammadInstanceRef.current = instance;

      // Marcar como lista para causar re-render
      setInstanceReady(true);

      // Obtener información del usuario en Zammad
      GET_CURRENT_USER_ZAMMAD(instance)
        .then(response => {
          setZammadUser(response.data);
          setZammadError(null);
        })
        .catch(error => {
          console.error('Error al obtener usuario de Zammad:', error);
          setZammadError(error);
        });
    }
  }, [accounts]);

  return (
    <ZammadContext.Provider value={{
      zammadInstance: zammadInstanceRef.current,
      zammadUser,
      zammadError,
      instanceReady
    }}>
      {children}
    </ZammadContext.Provider>
  );
};

export const useZammadContext = () => {
  const context = useContext(ZammadContext);
  if (!context) {
    throw new Error('useZammadContext debe ser usado dentro de un ZammadProvider');
  }
  return context;
};
